<template>
  <div id="app" class="white">
    <router-view />
  </div>
</template>

<style lang="scss">
@import "@/assets/css/white.scss";
@import "@/assets/css/black.scss";
@import "@/assets/css/common.scss";
#app {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}
</style>

<script>
import { mapActions } from "vuex";
// import store from "@/store";
export default {
  mounted() {
    // if (!store.getters.userName || store.getters.userName === "") {
    let locationHref = window.location.href;
    if (locationHref && locationHref.indexOf("?") > 0) {
      var userParm = locationHref.split("?")[1];
      var userName = userParm.split("userName=")[1];
      this.setUserName(userName);
    }
    if (locationHref && locationHref.indexOf("ihuberr") > 0) {
      var errParm = decodeURI(locationHref.split("?")[1]);
      if (errParm && errParm != "") {
        var errParm1 = errParm.split("&")[0];
        var errParm2 = errParm.split("&")[1];
      }
      if (errParm1 && errParm1 != "") {
        var status = errParm1.split("=")[1];
      }
      if (errParm2 && errParm2 != "") {
        var message = errParm2.split("=")[1];
      }
      this.$router.push({
        name: "ihuberr",
        params: {
          status: status,
          message: message
        }
      });
    } else {
      this.$router.push("/");
    }
    // }
  },
  methods: {
    ...mapActions(["setUserName"]),
  },
};
</script>